export const specialRoutes = {
  sixth_period_report_approval_request: "approval_request",
  sixth_period_report_approval_request2: "/sixth_period_report_list",
  personal_action_report_approval_request: "/Initiator/personal_action_form_reportlist",
  personal_action_report_approval_request2: "/personal_action_form_reportlist",
  handbook: "isHandbook",
  WAR_Classified_request: "approval_request",
  stipend_request: "/stipend_request",
  stipend_approver_request: "/initiator/stipend_form",
  stipend_payroll_request: "/payroll/stipend_list",
  WAR_Classified_Initiate_request: "/initiator/weekly_absence_report/",
  WAR_approver_request: "/approver/weekly_absence_report/",
  WAR_certificated_initiator_request: "/initiator/weekly_absent_report_certificated_admin/",
  WAR_certificated_approver_request: "/approver/weekly_absent_report_certificated_admin/",
  WAR_certificated_payroll_request: "/payroll/weekly_absent_report_certificated_admin/",
  WAR_payroll_request: "/payroll/weekly_absence_report/",
  substituteRequestClassified_request: "/initiator/substituteRequestClassified",
  substituteRequestClassified_request2: "/classified_substitute_request",
  substituteRequestCertificated_request: "/substitute_request_certificated/",
  personalServiceAgreement: "/personalserviceagreement",
  timeReport_request: "/time_report/",
};
